import { Box, Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import {
  ContentPipelineStage,
  PIPELINE_STAGES_WITH_CONTENT
} from "./higienizacao-progress";
import {
  getErrorMessage,
  getHigienizacaoIds,
  verifyStageStatus
} from "./utils";
import { Pipeline } from ".";
import { MailingTableRow } from "..";
import { bgError, changeAlfaRGB } from "components/dynamic-table/row-status";
import DynamicTable from "components/dynamic-table";

export function CurrentStepData({
  pipelineStage,
  modalData,
  row,
  index,
  activeStep
}: {
  pipelineStage: Pipeline["pipelineStage"];
  modalData: Pipeline[];
  row: MailingTableRow;
  index: number;
  activeStep: number;
}) {
  const currentStage = modalData.find((p) => p.pipelineStage === pipelineStage);

  const isError = verifyStageStatus({
    stage: pipelineStage,
    status: "ERROR",
    modalData
  });
  const isFinished = currentStage?.pipelineStatus === "FINALIZADO";
  const isSuspended = currentStage?.pipelineItemStatus === "SUSPENSO";
  const isPassed = activeStep > index || isFinished;
  const isCurrentStep = activeStep === index;

  const leadCount = currentStage?.mailingLeadCount;
  const showLeadCount = isPassed || isCurrentStep;
  const showTotal =
    currentStage?.pipelineStage === "ENVIA_ATENDIMENTO" && !!currentStage?.data;

  let stageData = modalData.find((p) => p.pipelineStage === pipelineStage);

  let shouldShowError = (isSuspended || isError) && isCurrentStep;
  let errorMessage: any[] | null = null;
  if (shouldShowError) errorMessage = getErrorMessage(stageData);
  //
  let higienizacaoIds = getHigienizacaoIds(stageData);

  const buttonText =
    shouldShowError && higienizacaoIds !== null
      ? "Executar novamente"
      : "Avançar etapa";

  const tooltipText = showTotal
    ? `Total: ${JSON.parse(currentStage?.data)?.total}`
    : showLeadCount
      ? `Quantidade de leads: ${leadCount ?? 0}`
      : undefined;

  if (isCurrentStep) {
    return (
      <Flex flexDir="column" p="0 0 0px 0">
        {shouldShowError &&
        pipelineStage !== "HIGIENIZACAO" &&
        errorMessage?.length ? (
          <DynamicTable
            size="sm"
            headerStyle={() => ({
              bg: changeAlfaRGB(bgError, 0.1),
              _hover: {}
            })}
            columns={[
              {
                name: `Erros:`,
                render: (mensagem) => (
                  <Box>
                    <Text
                      dangerouslySetInnerHTML={{
                        __html: `${mensagem}`
                      }}
                      whiteSpace="normal"
                      sx={{ br: { fontWeight: "bold" } }}
                    />
                  </Box>
                )
              }
            ]}
            pageSize={4}
            rows={errorMessage}
          />
        ) : null}

        {PIPELINE_STAGES_WITH_CONTENT.includes(pipelineStage) ? (
          <ContentPipelineStage
            modalData={modalData}
            pipelineStage={currentStage?.pipelineStage!}
            row={row}
            isCurrentStep={isCurrentStep}
          />
        ) : null}

        {["FILTRO"].includes(pipelineStage) ? (
          <>
            {tooltipText ? (
              <UnorderedList mb="8px">
                <ListItem>{tooltipText}</ListItem>
              </UnorderedList>
            ) : null}
            <Box
              w="100%"
              mt="10px"
              bg="gray.100"
              border={"1px solid var(--chakra-colors-gray-200)"}
              p="4px"
              borderRadius="10px"
              mb="8px"
            >
              <Text fontSize="12" whiteSpace="pre-wrap">
                <Text as="span" fontWeight="bold">
                  Atenção:
                </Text>
                <br />
                Se preferir você pode editar os filtros ou{" "}
                {buttonText.toLocaleLowerCase()}
              </Text>
            </Box>
          </>
        ) : null}
      </Flex>
    );
  } else {
    return null;
  }
}
